import * as core from '../../../../../../../core'

import { query } from './trends-table.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.trends.organization-trends-table',
    description:
      'Used for demo purposes on the Trends Page in tandem with stacked bar chart',
    name: 'RP Trends - Organization Trends Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
